export default {
  modalName: {
    id: 'cart_insurance_learn_more_modal_name',
    defaultMessage: 'BackUp protection',
  },
  baseLine: {
    id: 'insurance_modal_backup_baseline',
    defaultMessage: 'For the unexpected, get protected',
  },
  warranty: {
    id: 'insurance_modal_comparison_table_warranty',
    defaultMessage: 'Warranty',
  },
  comparisonTable1: {
    id: 'insurance_modal_comparison_table_benefit1',
    defaultMessage: 'Defects covered ',
  },
  comparisonTable2: {
    id: 'insurance_modal_comparison_table_benefit2',
    defaultMessage: 'Drops, spills, cracks ',
  },
  comparisonTable3: {
    id: 'insurance_modal_comparison_table_benefit3',
    defaultMessage: 'Battery replacement discount',
  },
  comparisonTable4: {
    id: 'insurance_modal_comparison_table_benefit4',
    defaultMessage: 'Refund if we can’t fix it',
  },
  goodDeedTitle: {
    id: 'insurance_modal_title_good_deed',
    defaultMessage: 'Double the good deed',
  },
  goodDeedBody1: {
    id: 'insurance_modal_body_good_deed_1',
    defaultMessage:
      'Not only is prolonging the life of your phone good for the earth, it’ll do some good for your fellow humans.',
  },
  goodDeedBody2: {
    id: 'insurance_modal_body_good_deed_2',
    defaultMessage:
      'In partnership with our insurance providers Cardif and Bolttech, we worked with CFA Ducretet, a refurbishment skills training center, to sponsor a workforce reintegration program that empowers participants to pursue promising careers as professional tech refurbishers.',
  },
}
